import { createContext } from 'react';

const MenuMobileContext = createContext({
  isOpen: false,
  setIsOpenAction: (isOpen: boolean) => {},
});

export default MenuMobileContext;
